import React from 'react'
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import SubscriptionItem from './SubscriptionItem'
import LatestNotificationsWrapper from '../../notifications/LatestNotificationsWrapper'

const SubscriptionSummaryWrapper = (props) => {
  const { clientSubscriptions, subscriptionGroupsData, latestAlerts } = props

  const latest_alerts_expanded = useSelector(state => state.settings.latest_alerts_expanded)
  
  const getSubscriptionGroupTitle = (group_name) => {
    const group = subscriptionGroupsData.find(item => item.group_name === group_name)
    return group ? group.title.value: ''
  }
  
  return (
    <Box sx={{ padding: '40px 20px' }}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: latest_alerts_expanded? 8 : 'grow' }}>
          {
            clientSubscriptions.map((item, index) => (
              <SubscriptionItem
                key={index}
                {...item}
                groupName={getSubscriptionGroupTitle(item.package_group)}
              />
            ))
          }
        </Grid>
        <Grid size={{ xs: 12, lg: latest_alerts_expanded? 4 : 'auto' }}>
          <LatestNotificationsWrapper
            bodyHeight={490}
            latestAlerts={latestAlerts}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default SubscriptionSummaryWrapper